<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { MeetingStopperViewModel } from '@Evaluation/Estimations/Components/MeetingStopper';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class MeetingStopper extends Vue
    {
        get vm(): MeetingStopperViewModel { return this.$props.viewModel as MeetingStopperViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get surveyStarted(): boolean { return this.vm.surveyStarted; }

        stopMeeting()
        {
            this.$emit('stopMeeting');
        }

        openSurvey()
        {
            this.$emit('openSurvey');
        }

        closeSurvey()
        {
            this.$emit('closeSurvey');
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Stopping the meeting</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">
                            You're about to end the meeting. Let's just tidy up a little...
                        </p><br />
                        <table class="table">
                            <tbody>
                                <tr v-if="surveyStarted">
                                    <td>
                                        <h5>Survey is open</h5>
                                        <p>The survey is still open. This means that people can still change their votes.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="closeSurvey">Close survey</button>
                                    </td>
                                </tr>
                                <tr v-if="!surveyStarted">
                                    <td>
                                        <h5>Survey is closed</h5>
                                        <p>The survey is closed. This means that people cannot change their votes.​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="openSurvey">Open survey</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button @click="stopMeeting" type="button" class="btn btn-primary">Stop the meeting</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>